import { useContext } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import Login from '../../pages/login/Login'
import { GlobalContext } from '../../context/Context'
import MySpaceLayout from '../../pages/my_space'
import ConfigLayout from '../../pages/config'
import ConfigAll from '../../pages/config/all'
import TrackerLayout from '../../pages/ledger'
import TrackerAll from '../../pages/ledger/all'
import ReportsLayout from '../../pages/reports'
import ReportsAll from '../../pages/reports/all'
import BillLayout from '../../pages/bills'
import BillsAll from '../../pages/bills/all'
import Dashboard from '../../pages/my_space/dashboard/index'


const MyRoutes = () => {
  let { state } = useContext(GlobalContext);
  return (
    <Routes>
      {(state?.isLogin === true) ? (
        <>
          <Route path='/my-space' element={<MySpaceLayout />} >
            <Route path='overview' element={<Dashboard />} />

            <Route index element={<Navigate to="/my-space/overview" replace />} />
            <Route path="*" element={<Navigate to="/my-space/overview" replace />} />
          </Route>

          <Route path='/configuration' element={<ConfigLayout />} >
            <Route path='all' element={<ConfigAll />} />

            <Route index element={<Navigate to="/configuration/all" replace />} />
            <Route path="*" element={<Navigate to="/configuration/all" replace />} />
          </Route>

          <Route path='/bills' element={<BillLayout />} >
            <Route path='all' element={<BillsAll />} />

            <Route index element={<Navigate to="/bills/all" replace />} />
            <Route path="*" element={<Navigate to="/bills/all" replace />} />
          </Route>

          <Route path='/reports' element={<ReportsLayout />} >
            <Route path='all' element={<ReportsAll />} />
            <Route index element={<Navigate to="/reports/all" replace />} />
            <Route path="*" element={<Navigate to="/reports/all" replace />} />
          </Route>

          <Route path='ledger' element={<TrackerLayout />} >
            <Route path='all' element={<TrackerAll />} />
            <Route index element={<Navigate to="/ledger/all" replace />} />
            <Route path="*" element={<Navigate to="/ledger/all" replace />} />
          </Route>

l         <Route index element={<Navigate to="/my-space/overview" replace />} />
          <Route path="*" element={<Navigate to="/my-space/overview" replace />} />
        </>
      )
        :
        (state?.isLogin === false) ?
          <>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={<Navigate to={'/login'} />} />
          </>
          :
          <></>
      }
    </Routes>
  )
}

export default MyRoutes